import { render, staticRenderFns } from "./static.vue?vue&type=template&id=2d2f60a1"
import script from "./static.vue?vue&type=script&lang=js"
export * from "./static.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeader: require('/home/forge/ab.farescraper.com/components/AppHeader.vue').default,StaticSection: require('/home/forge/ab.farescraper.com/components/StaticSection.vue').default,AppFooter: require('/home/forge/ab.farescraper.com/components/AppFooter.vue').default,AppMobileFooter: require('/home/forge/ab.farescraper.com/components/AppMobileFooter.vue').default})
